import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getSale = () => api.get("/sale").then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getCategory = (slug) => api.get(`/categories/${slug}`).then((r) => r.data);
export const getProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getRelated = (slug) => api.get(`/products/${slug}/related`).then((r) => r.data);
export const searchProducts = (q) => api.get("/search", { params: { q } }).then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const getFaqs = () => api.get("/faqs").then((r) => r.data);
export const getGallery = () => api.get("/gallery").then((r) => r.data);
export const createOrder = (order) => api.post("/orders", order).then((r) => r.data);

export default api;
